module.exports = __webpack_public_path__ + "static/media/icon-proposta.b1dc0983.svg";